import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalPedidoItemsDto, PedidoDto } from '../../../../../src/app/shared/model';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

@Component({
  selector: 'app-dialog-fecha-masiva-material',
  templateUrl: './dialog-fecha-masiva-material.component.html',
  styleUrls: ['./dialog-fecha-masiva-material.component.scss']
})

export class DialogFechaMasivaMaterialComponent implements OnInit {
  isLoading: boolean = false;
  public buttonCancelText: string;
  public buttonAcceptText: string;

  necesidadDate: Date = new Date();
  limiteDate: Date = new Date();
  formGroup: FormGroup;
  pedido: PedidoDto;
  isFechaPlanif: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<DialogFechaMasivaMaterialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalPedidoItemsDto,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions
  ) {
    this.pedido = this.data?.PedidoDto;
    this.isFechaPlanif = this.data?.Mode === 'FECHA_PLANIF';
  }

  ngOnInit(): void {
    this.buildForm();
  }

  onDecline() {
    this.dialogRef.close(null);
  }

  buildForm() {
    const today = new Date();

    if (this.isFechaPlanif) {
      this.formGroup = this.formBuilder.group({
        'FechaEntregaPlanificada': [today, [Validators.required]]
      });
    } else {
        this.necesidadDate.setDate((new Date()).getDate());
        this.limiteDate.setDate((new Date()).getDate());

        this.formGroup = this.formBuilder.group({
          'FechaNecesidad': [this.necesidadDate, [Validators.required]],
          'FechaLimite': [this.limiteDate, [Validators.required]],
        });
     }
  }

  checkToday() {
    if (this.isFechaPlanif) {
      const fechaPlanif = this.formGroup.get('FechaEntregaPlanificada')?.value;
      if (fechaPlanif && fechaPlanif < new Date()) {
        this.sharedFunctions.showMessage("La fecha de planificación debe ser mayor a la fecha actual", "Error");
        return false;
      }
    } else {
      const fechaNecesidad = this.formGroup.get('FechaNecesidad')?.value;
      if (fechaNecesidad && fechaNecesidad < new Date()) {
        this.sharedFunctions.showMessage("La fecha de necesidad debe ser mayor a la fecha actual", "Error");
        this.formGroup.get('FechaNecesidad')?.setValue(this.necesidadDate);
        return false;
      }
    }

    return true;
  }

  checkDate() {
    if(this.formGroup.controls.FechaNecesidad.value > this.formGroup.controls.FechaLimite.value || this.formGroup.controls.FechaLimite.value < new Date() ){
      this.sharedFunctions.showMessage("La fecha límite no puede ser menor a la fecha de necesidad", "Error");
      this.formGroup.controls.FechaLimite.setValue(this.formGroup.controls.FechaNecesidad.value);
      return false;
    }
    return true;
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
          this.formGroup.get(formFieldName)?.setValue(null);
    }
  }

  getErrorFechaNecesidad() {
    var v = this.formGroup.get('FechaNecesidad');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorFechaLimite() {
    var v = this.formGroup.get('FechaLimite');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorFechaPlanificacion() {
    var v = this.formGroup.get('FechaEntregaPlanificada');
    if (v.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  onGuardar() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Debe seleccionar una fecha válida", "Error");
      return false;
    }

    if (this.pedido && this.pedido.PedidoItems.length > 0) {
      this.pedido.PedidoItems = this.pedido.PedidoItems.map(item => ({
        ...item,
        ...this.formGroup.getRawValue()
      }));

      this.dialogRef.close(this.pedido);
    }
    else {
      this.dialogRef.close();
    }
  }
}
